import { Rect as FabricRect, FabricObject, Group } from "fabric";
import { useEffect } from "react";
import { InteractableCanvasElementProps } from "./Canvas";
import { rightAngleTriangle } from "./shapes/rightAngleTriangle";

type Props = {
  x: number;
  y: number;
  height: number;
  width: number;
  color: string;
  opacity: number;
  draggable: boolean;
} & InteractableCanvasElementProps;

const noMovement = {
  // don't show fabric controls ever
  hasControls: false,
  // don't ever allow rotation
  lockRotation: true,
};

const Rect = (props: Props) => {
  if (props.canvas == null) {
    throw new Error("Canvas Elements must the canvas prop passed");
  }
  useEffect(() => {
    const moveData = props.draggable ? { moveId: props.id } : undefined;
    const rect = new FabricRect({
      // don't allow movement on rect
      ...noMovement,
      // setup event
      data: moveData,
      originX: "left",
      originY: "top",
      // dimensions
      height: props.height,
      width: props.width,
      // positioning relative to group top-left
      left: 0,
      top: 0,
      // styling
      fill: props.color,
      opacity: props.opacity,
      stroke: props.draggable ? undefined : props.color,
      // dynamic event support.
      // TODO: should only be evented when draggable on
      evented: props.draggable,
    });

    const shapesToAdd: FabricObject[] = [rect];

    if (props.draggable) {
      shapesToAdd.push(rightAngleTriangle(props));
    }
    const group = new Group(shapesToAdd, {
      data: {
        id: props.id,
      },
      // disable fabric movement
      ...noMovement,
      // position explicitly at absolute coordinates
      left: props.x,
      top: props.y,
      originX: "left",
      originY: "top",
      // disable native fabric movement
      lockMovementX: true,
      lockMovementY: true,
      // evented: props.draggable,
      hasControls: false,
      // Fabric's default active-object border is drawn from the group's own
      // bounding box, which includes the oversized resize-handle triangle
      // sticking out past the rect's corner - always offset from the rect
      hasBorders: false,
      // allow rect and triangle to be evented individually
      subTargetCheck: true,
      evented: props.draggable,
    });

    props.canvas!.add(group);

    return function cleanupHighlight() {
      props.canvas!.remove(group);
    };
  }, [
    props.x,
    props.y,
    props.width,
    props.height,
    props.color,
    props.opacity,
    props.draggable,
  ]);

  return null;
};

export { Rect };
